/**
 * Утилита для проверки соответствия taskId
 */

// Проверяет, что taskId в данных соответствует ожидаемому taskId
export const validateTaskId = (data: any, expectedTaskId: string | null): boolean => {
  if (!expectedTaskId) return false;
  
  // Проверяем наличие taskId в данных
  if (!data || !data.task_id) {
    console.error('validateTaskId - taskId не найден в данных');
    return false;
  }
  
  // Проверяем соответствие taskId
  const isValid = data.task_id === expectedTaskId;
  
  if (!isValid) {
    console.error(`validateTaskId - несоответствие taskId: ожидался ${expectedTaskId}, получен ${data.task_id}`);
  }
  
  return isValid;
};

// Сохраняет информацию о выбранной задаче
export const saveTaskSelection = (taskId: string): void => {
  // Сохраняем в localStorage для долгосрочного хранения
  localStorage.setItem('report_task_id', taskId);
  localStorage.setItem('selected_task_timestamp', new Date().toISOString());
  
  // Дублируем в sessionStorage для сохранения при перезагрузке страницы
  sessionStorage.setItem('report_task_id', taskId);
  sessionStorage.setItem('selected_task_timestamp', new Date().toISOString());
  
  // Также сохраняем в URL только если мы на странице создания отчета
  try {
    const url = new URL(window.location.href);
    const pathname = url.pathname;
    
    // Проверяем, что мы на странице создания отчета
    const isReportCreationPage = pathname.includes('/create-report') || 
                                pathname.includes('/upload') || 
                                pathname.includes('/analytics') || 
                                pathname.includes('/processing') || 
                                pathname.includes('/custom');
    
    if (isReportCreationPage) {
      url.searchParams.set('taskId', taskId);
      window.history.replaceState({}, '', url);
      console.log(`saveTaskSelection - taskId добавлен в URL: ${taskId}`);
    } else {
      console.log(`saveTaskSelection - taskId НЕ добавлен в URL, так как страница не относится к созданию отчета: ${pathname}`);
    }
  } catch (e) {
    console.error('Ошибка при сохранении taskId в URL:', e);
  }
  
  console.log(`saveTaskSelection - сохранена информация о выбранной задаче: ${taskId}`);
};

// Получает информацию о выбранной задаче
export const getTaskSelection = (): { taskId: string | null, timestamp: string | null } => {
  // Сначала пытаемся получить из sessionStorage
  let taskId = sessionStorage.getItem('report_task_id');
  let timestamp = sessionStorage.getItem('selected_task_timestamp');
  
  // Если нет в sessionStorage, пытаемся получить из localStorage
  if (!taskId) {
    taskId = localStorage.getItem('report_task_id');
    timestamp = localStorage.getItem('selected_task_timestamp');
  }
  
  // Если нет ни в sessionStorage, ни в localStorage, пытаемся получить из URL
  if (!taskId) {
    try {
      const url = new URL(window.location.href);
      const urlTaskId = url.searchParams.get('taskId');
      if (urlTaskId) {
        taskId = urlTaskId;
        
        // Сохраняем только в хранилища, но не обновляем URL
        // Используем прямую запись в хранилища вместо вызова saveTaskSelection
        localStorage.setItem('report_task_id', urlTaskId);
        localStorage.setItem('selected_task_timestamp', new Date().toISOString());
        sessionStorage.setItem('report_task_id', urlTaskId);
        sessionStorage.setItem('selected_task_timestamp', new Date().toISOString());
        
        console.log(`getTaskSelection - taskId из URL сохранен в хранилища: ${urlTaskId}`);
      }
    } catch (e) {
      console.error('Ошибка при получении taskId из URL:', e);
    }
  }
  
  console.log(`getTaskSelection - получен taskId: ${taskId}`);
  return { taskId, timestamp };
};
